import { HeroTicker } from '../../product';

export const Partners = () => {
  return (
    <div className="bg-surface-blue py-9">
      <div className="container">
        <h1 className="text-title-5 md:text-title-3 lg:text-title-3 text-primary font-bold">Our Trusted Partners</h1>
      </div>
      <div>
        <HeroTicker />
      </div>
    </div>
  );
};
